import { render } from "./AxisLeft.vue?vue&type=template&id=64066487"
import script from "./AxisLeft.vue?vue&type=script&lang=js"
export * from "./AxisLeft.vue?vue&type=script&lang=js"
script.render = render

export default script